import './index.css';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import Text from '../text';
import Card from '../card';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Constants from '../../constants';
import { useSelector } from 'react-redux';
import { getRealBalanceObj } from '../../utilities/helper';
interface Props {
  onClickBack?: React.MouseEventHandler;
  title?: string;
  isBackButton?: boolean;
  bgColor?: boolean;
}

const NavigationHeader = ({ onClickBack, title, isBackButton = true }: Props) => {
  const { ComponentTheme: theme, DashboardTheme: dashboardTheme } = useTheme();
  const {
    teamName = '',

    xpPoints = 0,
    balanceInfo = 0
  } = useSelector((state: any) => state.user);

  const balance = getRealBalanceObj(balanceInfo);
  const headerTitle = {
    color: theme.headerTitle,
    marginLeft: isBackButton ? 0 : '25px'
  };
  const { isLandscape } = useWindowOrientation();
  const xpCoinContainerStyle = {
    background: dashboardTheme.dashBoardHeaderXpCoinContainerBg
  };
  return (
    <Card
      style={{
        backgroundColor: '#11171d',
        borderBottom: '1px solid #596779'
      }}
      className={`header-container ${isLandscape ? 'header-container__landscape' : ''}`}>
      {isBackButton && (
        <View className="header-back-button" onPress={onClickBack}>
          <ArrowBackIosIcon fontSize="large" style={{ color: 'white' }} />
        </View>
      )}
      <Text className="header-title" style={headerTitle}>
        {title}
      </Text>
      <div className="utility__area__mWeb">
        {teamName && (
          <React.Fragment>
            <div className="header__coin__container__mWeb" style={xpCoinContainerStyle}>
              <img src={Constants.Images.xp} width={30} />
              <Text className="header__xp__coins__txt">{xpPoints}</Text>
            </div>
            <div className="header__xp__container__mWeb" style={xpCoinContainerStyle}>
              <img className="header__Coins__img__mWeb" src={Constants.Images.coin} />
              <Text className="header__xp__coins__txt__mWeb">{balance['totalBalance']}</Text>
              <img
                className="header__addCashPlus__img__mWeb"
                src={Constants.Images.addCashPlus}
                width={'15px'}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </Card>
  );
};
export default React.memo(NavigationHeader);
